import { Flex, Heading, Text } from "@chakra-ui/react";
import { ReactElement, useContext } from "react";
import { FormattedMessage } from "react-intl";
import { PartnerProgramInfo } from "./partner-program-info";
import { StatisticsButton } from "./statistics-button";
import { VideoBackground } from "./video-background";
import { Greeting } from "@iloq/shared-react/frontpage/greeting";
import VueContext from "@iloq/shared-react/vueContext";
import { CorePermission } from "@iloq/shared/CorePermission";

export function HeroPartner(): ReactElement {
  const {
    $store: {
      state: {
        partnerInfo: { partnerInfo },
        user,
      },
    },
  } = useContext(VueContext);

  const tier = partnerInfo?.partnerTier;
  const hasPartnerProgramRights = user.hasPermissions([CorePermission.partnerProgram]);

  return (
    <Flex
      flexDirection="column"
      color="white"
      gap="8"
      marginTop={{ base: "-27px", sm: "-11px", md: "-11px", lg: "-15px", xl: "-31px" }}
      marginLeft="-45px"
      marginRight="-45px"
      position="relative"
    >
      <VideoBackground />

      <Flex
        flexDir="row"
        marginX="3xl"
        marginTop="md"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap="4"
        zIndex="1"
      >
        <Flex flexDir="column">
          <Heading as="h1" mb="sm" fontWeight="normal">
            <Greeting firstName={user?.firstName} />
          </Heading>

          <Text>
            <FormattedMessage id="frontpage.mainContent.paragraph1" />
          </Text>
        </Flex>

        {hasPartnerProgramRights && <StatisticsButton tier={tier} />}
      </Flex>

      <PartnerProgramInfo
        partnerInfo={partnerInfo}
        hasPartnerProgramRights={hasPartnerProgramRights}
        hasCreateOpportunityRights={user.hasPermissions([
          CorePermission.partnerProgramCreateOpportunity,
        ])}
      />
    </Flex>
  );
}
